<template>
  <div>
    <bookings-late-arrivals-tabla :data="data" />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import { getBookingsLateArrivals } from "../../../constants/lineas";

import BookingsLateArrivalsTabla from "../../../components/tablas/lineas/BookingsLateArrivalsModalTabla";

export default {
  components: { BookingsLateArrivalsTabla },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", ["dataDatatableBookingsLateArrivalsFiltrada"]),
    
  },
  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoading",
      "ActionSetLoadingTable",
    ]),
    ...mapActions("lineas", [
      "actionSetDataBookingsLateArrivals",
      "actionSetDataListaSemanaLA",
      "actionSetDataListaAnioLA",
      "actionSetDataListaPodLA",
      "actionSetDataListaClienteLA",
      "actionSetDataListaComercialLA"
    ]),

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async getDataLateArrivals() {

      this.ActionSetLoadingTable(true);
      
      const dataDB = await getBookingsLateArrivals();

      this.actionSetDataListaSemanaLA(dataDB.filtroSemana);
      this.actionSetDataListaAnioLA(dataDB.filtroAnio);
      this.actionSetDataListaPodLA(dataDB.filtroPod);
      this.actionSetDataListaClienteLA(dataDB.filtroCliente);
      this.actionSetDataListaComercialLA(dataDB.filtroComercial);
      
      this.actionSetDataBookingsLateArrivals(dataDB.data_table);


    },
  },
  created() {
    this.getDataLateArrivals();
    this.actualizarURL();


  },
  watch: {
    dataDatatableBookingsLateArrivalsFiltrada: function (_new) {

      if (_new) {
        this.data = _new;
        this.actualizarURL();
      }
    },
  },
};
</script>

<style></style>
